import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const SETTIMEZONE = () => {
  return (
    <CardSection id="SETTIMEZONE" title="SETTIMEZONE">
      <Paragraph>특정 시간의 시간대를 지정한 시간대로 변경합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>SETTIMEZONE(DATETIME, TIME_ZONE)</Paragraph>
        <Ul>
          <Li>
            <b>DATETIME</b>은 시간대를 설정하려는 시간입니다.
          </Li>
          <Li>
            <b>TIME_ZONE</b>은 날짜/시간 객체와 연결하려는 시간대입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>현재 지원 준비중인 함수입니다.</Paragraph>
      </ListSection>
    </CardSection>
  );
};
